import { apiClient } from '@/lib/api'

const DEVELOPERS_BASE = '/v1/estates/manage-developers'

/**
 * Developers API (Superadmin only)
 * CRUD operations for developers
 */

// Get all developers with filters
export const getDevelopers = async (params = {}) => {
  const response = await apiClient.get(`${DEVELOPERS_BASE}/`, { params })
  return response
}

// Get developer by ID
export const getDeveloper = async (id) => {
  const response = await apiClient.get(`${DEVELOPERS_BASE}/${id}/`)
  return response
}

// Create new developer
export const createDeveloper = async (data) => {
  const response = await apiClient.post(`${DEVELOPERS_BASE}/`, data)
  return response
}

// Update developer (PUT - full update)
export const updateDeveloper = async (id, data) => {
  const response = await apiClient.put(`${DEVELOPERS_BASE}/${id}/`, data)
  return response
}

// Partial update developer (PATCH)
export const patchDeveloper = async (id, data) => {
  const response = await apiClient.patch(`${DEVELOPERS_BASE}/${id}/`, data)
  return response
}

// Delete developer
export const deleteDeveloper = async (id) => {
  const response = await apiClient.delete(`${DEVELOPERS_BASE}/${id}/`)
  return response
}
